<form class="datasource-form" [formGroup]="form">
  <app-form>
    <app-row>
      <app-field [label]="'Тип источника'">
        <p-dropdown
          formControlName="type"
          placeholder="Выберите тип источника"
          [options]="sourceTypes"
          [class.loading]="loading"
        />
      </app-field>

      <app-field *ngIf="typeControl.value !== types.Jdbc" [label]="'Значение по умолчанию'">
        <p-dropdown
          formControlName="defaultValue"
          placeholder="Введите значение по умолчанию"
          [options]="defaultValues"
          [editable]="true"
          [showClear]="true"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <ng-container [ngSwitch]="typeControl.value">
      <ng-container *ngSwitchCase="types.Jdbc">
        <app-row>
          <app-field [label]="'JDBC-драйвер'">
            <input
              pInputText
              type="text"
              formControlName="driver"
              placeholder="Введите имя драйвера"
              [class.loading]="loading"
            />
          </app-field>
        </app-row>

        <app-row>
          <app-field [label]="'Строка подключения к источнику данных'">
            <input pInputText type="text" formControlName="uri" placeholder="Введите URI" [class.loading]="loading" />
          </app-field>
        </app-row>

        <app-row>
          <app-field [label]="'Логин'">
            <input
              pInputText
              type="text"
              formControlName="username"
              placeholder="Введите логин для подключения к БД"
              [class.loading]="loading"
            />
          </app-field>

          <app-field [label]="'Пароль'">
            <p-password
              formControlName="password"
              placeholder="Введите пароль для подключения к БД"
              [feedback]="false"
              [toggleMask]="true"
              [class.loading]="loading"
            />
          </app-field>
        </app-row>

        <app-row>
          <app-field [label]="'Запрос'">
            <div class="absolute_top-right">
              <app-open-editor
                [language]="'sql'"
                [code]="queryControl.value || ''"
                (codeChange)="queryControl.setValue($event)"
              ></app-open-editor>
            </div>

            <textarea
              pInputTextarea
              [autoResize]="true"
              rows="3"
              formControlName="query"
              placeholder="Введите запрос"
              [class.loading]="loading"
            ></textarea>
          </app-field>
        </app-row>
      </ng-container>

      <ng-container *ngSwitchCase="types.Api">
        <app-row>
          <app-field class="width_auto" [label]="'Метод'">
            <p-dropdown
              formControlName="method"
              placeholder="Выберите метод"
              [options]="methods"
              [class.loading]="loading"
            />
          </app-field>

          <app-field [label]="'Адрес API'">
            <p-dropdown
              formControlName="uri"
              placeholder="Введите адрес"
              [options]="apiEndpoints"
              [editable]="true"
              [showClear]="true"
              [class.loading]="loading"
            />
          </app-field>
        </app-row>

        <app-row>
          <app-field [label]="'Заголовки'">
            <app-key-value-array
              [form]="form.controls.headers"
              [keySource]="headersKeys"
              [valueSource]="headersValues"
              [class.loading]="loading"
            ></app-key-value-array>
          </app-field>
        </app-row>

        <app-row>
          <app-field [label]="'Тело (body)'">
            <app-key-value-array
              [form]="bodyControl"
              [valueSource]="dependsOnValue"
              [class.loading]="loading"
            ></app-key-value-array>
          </app-field>
        </app-row>
      </ng-container>
    </ng-container>
  </app-form>
</form>
